import { Map, fromJS, List } from 'immutable'
import { FOCUS_BY } from '../../components/ConditionDiagrams/MapInteractivity'
import uuid from 'uuid/v4'

export const mapInteractivity = (actionTarget, retState, appState = {}, detectIsTargetKeyInRepeatEl, index) => {
  const actionTargetJS = actionTarget.getIn(['0'], Map()).toJS()

  if (!actionTargetJS.enabled) return retState
  if (actionTargetJS.focusOn && actionTargetJS.focusBy === FOCUS_BY.PIN) {
    const pinValue = actionTargetJS?.focusOn?.pinValue
    if (!pinValue) {
      return retState
    }
    let value = ''
    if (_.get(pinValue, 'type', 'static') === 'static') {
      value = _.get(pinValue, 'textValue', '')
    } else {
      const valuePath = String(pinValue?.field).split(':')
      if (detectIsTargetKeyInRepeatEl(valuePath, retState)) {
        value = _.get(appState, [...valuePath, ...(index !== null && index !== undefined ? [index] : [])], '')
      } else {
        value = _.get(appState, valuePath, '')
      }
    }
    const focusOnMap = actionTargetJS.focusOn.map
    let pageUID = focusOnMap.pageID
    retState.getIn(['project', 'Pages'], List()).map((page) => {
      if (page.get('_id') === focusOnMap.pageID) {
        pageUID = focusOnMap.pageID = page.get('uid')
      }
    })
    retState = retState.setIn(['state', pageUID, focusOnMap.value, 'focusOnValue'], value)
  } else if (actionTargetJS.focusOn && actionTargetJS.focusBy) {
    const focusOnMap = actionTargetJS.focusOn.map
    if (actionTargetJS.focusBy === FOCUS_BY.FIELD) {
      const focusOnLat = actionTargetJS.focusOn.field.lat
      const lat = retState.getIn(['state', ...focusOnLat.value.split(':')])
      const focusOnLng = actionTargetJS.focusOn.field.lng
      const lng = retState.getIn(['state', ...focusOnLng.value.split(':')])
      let pageUID = focusOnMap.pageID
      retState.getIn(['project', 'Pages'], List()).map((page) => {
        if (page.get('_id') === focusOnMap.pageID) {
          pageUID = focusOnMap.pageID = page.get('uid')
        }
      })
      retState = retState.setIn(
        ['state', pageUID, focusOnMap.value, 'focusOn'],
        fromJS({ ...{ lat, lng }, zoom: 5, id: uuid() })
      )
    }
  }

  return retState
}
